import { AutoMap } from "@automapper/classes"
import { Consommable } from "./consommable"
import { SamplingPoint } from "./sampling-point"
import { Flacon } from "./flacon"
import { BaseDOM } from "./base.dom"

export class Prelevement extends BaseDOM<Prelevement> {
    @AutoMap()
    Code: string = ''
    @AutoMap()
    OgiCode: string = ''
    @AutoMap()
    SamplingJobId: number = 0
    @AutoMap()
    ClientCode: string = ''
    @AutoMap()
    Comment?: string;
    @AutoMap()
    SamplingPoint: SamplingPoint = new SamplingPoint()
    @AutoMap(() => [Consommable])
    ConsommableList: Consommable[] = [];
    @AutoMap(() => [Flacon])
    FlaconList: Flacon[] = [];
}